import axios from 'axios';
import localforage from 'localforage';

const BASE_URL = 'https://hacker-news.firebaseio.com/v0';

export const getTopStoryIds = async (offlineMode = false) => {
  try {
    if (offlineMode) {
      const cachedData = await localforage.getItem('topStoryIds');
      return cachedData || [];
    }
    const response = await axios.get(`${BASE_URL}/topstories.json`);
    const data = response.data;
    await localforage.setItem('topStoryIds', data);
    return data;
  } catch (error) {
    console.error('Error fetching top story IDs:', error);
    throw error; // Re-throw the error for handling in the component
  }
};

export const getItem = async (itemId, offlineMode = false) => {
  try {
    if (offlineMode) {
      const cachedData = await localforage.getItem(`item-${itemId}`);
      return cachedData || null;
    }

    const response = await axios.get(`${BASE_URL}/item/${itemId}.json`);
    const data = response.data;
    await localforage.setItem(`item-${itemId}`, data);
    return data;
  } catch (error) {
    console.error(`Error fetching item ${itemId}:`, error);
    throw error;
  }
};